import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M629.228039 331.011026L0 960.239065 629.228039 1589.4671 785.129292 1433.56585 422.057987 1070.49455 1919.98897 1070.49455 1919.98897 849.983582 422.057987 849.983582 785.129292 486.912278z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconArrowLeftSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconArrowLeftSolid, _Component);

  var _super = _createSuper(IconArrowLeftSolid);

  function IconArrowLeftSolid() {
    _classCallCheck(this, IconArrowLeftSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconArrowLeftSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconArrowLeftSolid /> is deprecated. Please use <IconArrowStartSolid /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconArrowLeft",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconArrowLeftSolid.displayName = "IconArrowLeftSolid";
  return IconArrowLeftSolid;
}(Component);

IconArrowLeftSolid.glyphName = 'arrow-left';
IconArrowLeftSolid.variant = 'Solid';
IconArrowLeftSolid.deprecated = true;
IconArrowLeftSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconArrowLeftSolid;
export { IconArrowLeftSolid };